import { PayloadAction, ReducerCreators } from '@reduxjs/toolkit';

import { ChannelAnalyticsState } from './types';
import { IStatsWrapper } from '@/types/analytics';
import GetChannelEvents from '@/connection/analytics/channel-level/get-channel-events';

export const reducers = (create: ReducerCreators<ChannelAnalyticsState>) => ({
  updateFetchedChannelStats: create.reducer(
    (state, action: PayloadAction<{ key: keyof ChannelAnalyticsState } & Partial<IStatsWrapper>>) => {
      const { key, ...rest } = action.payload;
      // @ts-expect-error handle complex spread type
      state[key] = {
        ...state[key],
        ...rest,
      };
    }
  ),
  fetchMoreChannelProjects: create.asyncThunk(
    async ({
      channel,
      start,
      end,
      audienceLists,
      offset,
      search,
      sort,
    }: {
      clearExisting?: boolean;
      channel: number;
      start?: number;
      end?: number;
      audienceLists?: string[];
      offset?: number;
      search?: string;
      sort?: string;
    }) => {
      const moreProjects = await GetChannelEvents({
        channel,
        start,
        end,
        audienceLists,
        offset,
        search,
        sort,
      });
      return moreProjects;
    },
    {
      pending: (state) => {
        state['ChannelProjects'].loading = true;
      },
      fulfilled: (state, action) => {
        if (state['ChannelProjects'].data) {
          state['ChannelProjects'].data = [
            ...(action.meta.arg.clearExisting ? [] : state['ChannelProjects'].data),
            ...action.payload,
          ];
        }
      },
      settled: (state) => {
        state['ChannelProjects'].loading = true;
      },
    }
  ),
});
